import React, { useState } from 'react';
import api from '../services/api';
import './Login.css';

export default function Login({ onLogin, branding }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { username, password });
      onLogin(data.token, data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'Connexion impossible');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand">
          {branding.logo_url
            ? <img src={branding.logo_url} alt="" className="login-logo" />
            : <div className="login-logo-fallback">{(branding.short_name || 'G').charAt(0)}</div>}
          <h1>{branding.app_title || 'Gestion'}</h1>
        </div>

        <div className="form-group">
          <label htmlFor="username">Identifiant</label>
          <input id="username" className="form-control" value={username}
            onChange={(e) => setUsername(e.target.value)} autoComplete="username" autoFocus />
        </div>
        <div className="form-group">
          <label htmlFor="password">Mot de passe</label>
          <input id="password" type="password" className="form-control" value={password}
            onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        </div>

        {error && <div className="form-error" style={{ marginBottom: 12 }}>{error}</div>}

        <button type="submit" className="btn-primary" style={{ width: '100%', height: 42 }} disabled={loading}>
          {loading ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}
